import { SectionHead } from "@/features/shell/EmptyState";
import { BattlePlanPanel } from "./BattlePlanPanel";

/**
 * Execution: what is actually being done today and this week.
 *
 * The long-range plans and their Gantt charts are not here — they belong to the
 * activity that owns them, and are shown on its card. This page is only the battle
 * plans: existing tasks boxed into a period.
 */
export function PlanningPage() {
  return (
    <main className="console">
      <SectionHead title="Battle plans" />
      <div className="bp-grid">
        <BattlePlanPanel kind="daily" title="Today" />
        <BattlePlanPanel kind="weekly" title="This week" />
      </div>
    </main>
  );
}
